import { createSelector } from 'reselect';
import { RootState } from 'shared/stores';

export const exadisStateSelector = (state: RootState) => state.rp4.exadis

export const exadisLoading = createSelector(exadisStateSelector, state => state.uploadLoading)
export const exadisResponse = createSelector(exadisStateSelector, state => state.uploadResponse);
export const toggleNavigation = createSelector(exadisStateSelector, state => state.showNavigation)
export const navSelectedKey = createSelector(exadisStateSelector, state => state.navigationSelectedKey)